export default __webpack_public_path__ + "static/media/information--dead-end-right--g1.b3196029.png";